<template>
  <v-layout class="criterio-radio-button">
    <v-flex class="d-flex" cols="12" sm="6">
      <v-radio-group v-model="data" hide-details :disabled="disabled" @change="input">
        <label>
          {{ label }}
          <v-tooltip v-if="tooltip" right max-width="350px">
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <mf-icon small color="cinza-0">info</mf-icon>
              </span>
            </template>
            <span>{{ tooltip }}</span>
          </v-tooltip>
        </label>
        <label v-if="subtitle" class="subtitle pt-1 pb-3">{{ subtitle }}</label>
        <v-radio v-for="value in values" :key="value.id" :label="value.label" :value="value.id">
          <template v-slot:label>
            <v-tooltip v-if="value.tooltip" right max-width="350px">
              <template v-slot:activator="{ on }">
                <span v-on="on"> {{ value.label }} <mf-icon small color="cinza-0" class="ml-1">info</mf-icon> </span>
              </template>
              <span>{{ value.tooltip }}</span>
            </v-tooltip>
            <span v-else> {{ value.label }} </span>
          </template>
        </v-radio>
      </v-radio-group>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {},
  props: {
    values: {},
    label: String,
    currentIndex: Number,
    initialValue: {},
    tooltip: String,
    subtitle: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    data: 0,
  }),

  computed: {
    ...mapGetters(['highlightProducts']),
    currentChildren() {
      return this.values.find((valueToFind) => {
        return valueToFind.id === this.data
      })
    },
  },

  watch: {
    highlightProducts() {
      if (this.initialValue === 0 || this.data === 0) {
        this.data = 0
        this.input(0)
      }
    },
    data(newValue, oldValue) {
      if (newValue === 0 && oldValue === 1) {
        this.$nextTick(() => {
          this.$emit('input', {
            currentValue: 0,
            currentChildren: this.currentChildren,
            currentIndex: this.currentIndex,
            affectsChildren: true,
          })
        })
      }
    },
  },

  mounted() {
    this.data = this.initialValue
    if (this.initialValue === 0) this.input(0)

    this.validate()
  },

  methods: {
    input(value) {
      this.$emit('input', {
        currentValue: value === 0 ? this.highlightProducts : value,
        currentChildren: this.currentChildren,
        currentIndex: value === 0 ? this.currentIndex + 1 : this.currentIndex,
        affectsChildren: true,
      })

      if (value === 0) {
        this.$emit('remove-branch', { index: this.currentIndex + 2 })
      }

      this.validate()
    },

    validate() {
      this.$emit('validate', { isValid: true, currentIndex: this.currentIndex })
    },
  },
}
</script>

<style lang="scss">
.criterio-radio-button {
  .v-input {
    margin-top: 0;
  }
}
</style>
